import React from "react";
import classes from "./error404.module.scss";

const Error = () => <div className={classes["error"]}> Error 404</div>;

export default Error;
